
import React from 'react';
import { AdminAffiliateLimitsManagement } from '@/components/admin/affiliate/AdminAffiliateLimitsManagement';

export const AffiliateLimitsPage = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Affiliate Usage Limits</h1>
        <p className="text-muted-foreground mt-1">
          Configure and manage Market Analysis usage limits for affiliates
        </p>
      </div>
      
      <AdminAffiliateLimitsManagement />
    </div>
  );
};

export default AffiliateLimitsPage;
